import React from 'react';
import { useNavigate } from 'react-router-dom';
import Toncoin from "../assets/image/toncoin.svg";
import SCoin from "../assets/image/S-coint.svg";
import "./style/CaseCard.css";

export default function CaseCard({ caseItem }) {
  const navigate = useNavigate();
  const priceRub = caseItem.value * 1.65;

  return (
    <div
      onClick={() => navigate(`/case/${caseItem.id}`)}
      className="case-card"
      style={{
        "--glow-color": `${caseItem.color}`,
        "--glow-color-soft": 'color-mix(in srgb, var(--glow-color) 30%, transparent)'
      }}
    >
      <div className="cardPrice">
          <h4 className='card-h4'>{caseItem.name}</h4>
          <div className="prices">
            <span className='price card-span'><img src={Toncoin} alt="toncoin" />1.251</span>
            <span className='or card-span'>/</span>
            <span className='price card-span'><img src={SCoin} alt="s-coin" />{priceRub}</span>
          </div>
      </div>
      <img
        src={caseItem.image}
        alt={caseItem.name}
        className="case-card-img"
      />
      <div
        className="case-down"
      ></div>
    </div>
  );
}
